var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-layout"},[_c('div',{staticClass:"page-navbar"},[_c('AuthNavbar')],1),_c('div',{staticClass:"page-content"},[_c('router-view',{staticClass:"page-content-container"}),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }